import { atom } from 'jotai';

// 用于隔离 page 相关的 jotai states
export const PAGE_SCOPE = Symbol('Page Scope');

export const $pageId = atom<string>('');
